<div class="truckJourneyDelivery">
    <span class="font-bold" [i18n]="'truck-journeys.detail.deliveries-colon'"></span>

    <div class="truckJourneyDelivery-container">
        <app-delivery-number *ngFor="let delivery of deliveries.slice(0, MAX_SHOWN_DELIVERY_NUMBERS_BEFORE_HIDDEN)"
                             [deliveryNumber]="delivery.number"
                             [salesOrderNumber]="delivery.salesOrderNumber"
                             [stopType]="delivery.stopType"
                             displayType="badge">
        </app-delivery-number>

        <div *ngIf="deliveries.length > MAX_SHOWN_DELIVERY_NUMBERS_BEFORE_HIDDEN"
             class="badge _info"
             (mouseover)="showTooltip = true"
             (mouseleave)="showTooltip = false">
            +{{ deliveries.length - MAX_SHOWN_DELIVERY_NUMBERS_BEFORE_HIDDEN }}
        </div>
        <app-hidden-deliveries-tooltip *ngIf="showTooltip"
                                       [hiddenDeliveries]="deliveries.slice(this.MAX_SHOWN_DELIVERY_NUMBERS_BEFORE_HIDDEN)"
                                       [style.left.px]="500"
                                       [style.top.px]="500">
        </app-hidden-deliveries-tooltip>
    </div>
</div>
